<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <table class="c-indicator c-indicator-w-100">
      <thead>
        <tr>
          <th class="tab-wid-80">№<br /></th>
          <template v-if="viewCategories">
            <th class="tab-wid-250">Категория</th>
            <th class="tab-wid-250">Группа</th>
            <th class="tab-wid-250">Страна</th>
          </template>
          <template v-if="!viewCategories">
            <th class="tab-wid-80">Группа оборудования</th>
            <th class="tab-wid-122">
              Код оборудования
            </th>
            <th class="tab-wid-250">
              Вид оборудования
            </th>
          </template>
          <th>
            Наименование закупаемого оборудования
          </th>
          <th>
            Количество
          </th>
          <th class="tab-wid-80"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in $parent.project.PURCHASED_EQUIPMENT.items">
          <td class="tab-wid-80">{{ index + 1 }}</td>
          <template v-if="viewCategories">
            <td class="tab-wid-80 break">{{ getCategoryName(item.UF_CATEGORIES_ID) }}</td>
            <td class="tab-wid-80 break">{{ getGroupDisplay(item) }}</td>
            <td class="tab-wid-80 break">{{ getCountryName(item.UF_COUNTRY_ID) }}</td>
          </template>
          <template v-if="!viewCategories">
            <td class="tab-wid-80">
              {{ medName(item.UF_VID_GROUP_ID) }}
            </td>
            <td class="tab-wid-80">
              {{ groupCode(item.UF_VID_GROUP_ID, item.UF_VID_ID) }}
            </td>
            <td class="tab-wid-80">
              {{ groupName(item.UF_VID_GROUP_ID, item.UF_VID_ID) }}
            </td>
          </template>
          <td class="tab-wid-80">{{ item.UF_DESCRIPTION }}</td>
          <td class="tab-wid-80">
            <span v-if="item.UF_COUNT_FROM !== item.UF_COUNT_TO"
              >от {{ item.UF_COUNT_FROM }} до {{ item.UF_COUNT_TO }}</span
            >
            <span v-else>{{ item.UF_COUNT_FROM }}</span>
          </td>
          <td
            v-if="
              !$parent.$parent.projectDisabled &&
                !$parent.project.UF_IS_BLOCK &&
                $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1
            "
          >
            <i class="i-edit centerIcon" @click="editItem(index)"></i>
            <i
              class="i-delete centerIcon"
              title="Удалить запись"
              @click="deleteItem(index, item)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div
      class="add-row"
      v-show="
        !$parent.$parent.projectDisabled &&
          !$parent.project.UF_IS_BLOCK &&
          $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1
      "
    >
      <a class="link-add-row" @click="showAddItem">Добавить</a>
    </div>
    <div
      class="modal fade in"
      v-bind:class="{ show: showForm }"
      v-if="showForm"
      tabindex="-1"
      role="dialog"
    >
      <form v-on:submit.prevent="submit">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                @click="showForm = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                {{ Object.keys(item).length > 0 ? "Изменить" : "Добавить" }}
                позицию
              </h4>
            </div>
            <div class="modal-body">
              <template v-if="viewCategories">
                <div
                  class="form-group"
                  v-bind:class="{ 'has-error': checkError('UF_CATEGORIES_ID') }"
                >
                  <label>Категория</label>
                  <div class="clear"></div>
                  <select
                    v-model="item.UF_CATEGORIES_ID"
                    class="form-control"
                    @change="onCategoryChange"
                  >
                    <option :value="undefined"></option>
                    <option
                      v-for="cat in categoriesTree"
                      :value="cat.ID"
                      :key="cat.ID"
                      v-text="cat.NAME"
                    ></option>
                  </select>
                </div>
                <div
                  class="form-group"
                  v-if="!singleOtherGroup"
                  v-bind:class="{
                    'has-error': checkError('UF_CATEGORIES_GROUP_ID')
                  }"
                >
                  <label>Группа</label>
                  <div class="clear"></div>
                  <select
                    v-model="item.UF_CATEGORIES_GROUP_ID"
                    class="form-control"
                    :disabled="!item.UF_CATEGORIES_ID"
                    @change="onGroupChange"
                  >
                    <option :value="undefined"></option>
                    <option
                      v-for="group in selectedCategoryGroups"
                      :value="group.ID"
                      :key="group.ID"
                      v-text="group.NAME"
                    ></option>
                  </select>
                </div>
                <div
                  class="form-group"
                  v-if="selectedGroupIsOther"
                  v-bind:class="{ 'has-error': checkError('UF_CATEGORIES_DESC') }"
                >
                  <label>Описание группы<span class="red">*</span></label>
                  <textarea
                    type="text"
                    class="form-control"
                    v-model="item.UF_CATEGORIES_DESC"
                    maxlength="200"
                  />
                </div>
                <div class="form-group">
                  <label>Страна</label>
                  <div class="clear"></div>
                  <select v-model="item.UF_COUNTRY_ID" class="form-control">
                    <option :value="undefined"></option>
                    <option
                      v-for="country in directory.country"
                      :value="country.ID"
                      :key="country.ID"
                      v-text="country.NAME"
                    ></option>
                  </select>
                </div>
              </template>
              <template v-if="!viewCategories">
                <div
                  class="form-group"
                  v-bind:class="{ 'has-error': checkError('UF_VID_GROUP_ID') }"
                >
                  <label>Группа оборудования<span class="red">*</span></label>
                  <select v-model="item.UF_VID_GROUP_ID" class="form-control">
                    <option
                      v-for="item in cGroupStartSelect"
                      v-bind:value="item.ID"
                      v-bind:key="item.ID"
                      v-text="item.NAME"
                    ></option>
                  </select>
                </div>
                <div
                  class="form-group"
                  v-bind:class="{ 'has-error': checkError('UF_VID_ID') }"
                >
                  <label>Вид оборудования<span class="red">*</span></label>
                  <select v-model="item.UF_VID_ID" class="form-control">
                    <option
                      v-for="item in cGroup"
                      v-bind:value="item.ID"
                      v-bind:key="item.ID"
                      v-text="item.NAME"
                    ></option>
                  </select>
                </div>
              </template>
              <div
                class="form-group"
                v-bind:class="{
                  'has-error': checkError('UF_DESCRIPTION')
                }"
              >
                <label>Наименование<span class="red">*</span></label>
                <input
                  type="text"
                  maxlength="200"
                  class="form-control"
                  v-model="item.UF_DESCRIPTION"
                />
              </div>
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_COUNT_FROM') }"
              >
                <label>Количество<span class="red">*</span></label>
                <div class="clear"></div>
                <input
                  type="text"
                  placeholder="от"
                  style="display: inline;width: auto"
                  class="form-control"
                  v-model="item.UF_COUNT_FROM"
                  @keypress="isNumber($event)"
                />
                <input
                  type="text"
                  placeholder="до"
                  style="display: inline;width: auto"
                  class="form-control"
                  v-model="item.UF_COUNT_TO"
                  @keypress="isNumber($event)"
                />
              </div>
              <button type="button" @click="submit" class="btn btn-info">
                Сохранить
              </button>
              <button
                type="button"
                @click="showForm = false"
                class="btn btn-default btn-style-big"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";
import { ProjectsService } from "@/common/api.service";

export default {
  name: "EquipmentMarkirovka",
  data() {
    return {
      showForm: false,
      editIndex: 0,
      item: {
        UF_VID_GROUP_ID: 0
      },
      errorFields: {},
      nameEquipment: "ProjectPurchasedEquipmentModel"
    };
  },
  created() {
    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]);
    this.$store.dispatch(FETCH_DIRECTORY, ["tree/group_med_oborudovanie"]);
    //справочники категорий грузим только при включенном признаке EQUIPMENT_CATEGORIES_VIEW
    if (this.viewCategories) {
      this.$store.dispatch(FETCH_DIRECTORY, ["country"]);
      this.$store.dispatch(FETCH_DIRECTORY, [
        "tree/sp_categories_of_purchased_equipment"
      ]);
    }
  },
  computed: {
    ...mapGetters(["directory"]),

    viewCategories() {
      const setting =
        this.$parent &&
        this.$parent.project &&
        this.$parent.project.UF_SETTING;
      return !!(setting && parseInt(setting.EQUIPMENT_CATEGORIES_VIEW) === 1);
    },
    categoriesTree() {
      return this.directory.tree_sp_categories_of_purchased_equipment || [];
    },
    selectedCategoryGroups() {
      let catId = parseInt(this.item.UF_CATEGORIES_ID) || 0;
      if (catId > 0) {
        let cat = this.categoriesTree.find(x => parseInt(x.ID) === catId);
        if (cat && Array.isArray(cat.CHILD)) {
          return cat.CHILD;
        }
      }
      return [];
    },
    selectedGroupIsOther() {
      let groupId = parseInt(this.item.UF_CATEGORIES_GROUP_ID) || 0;
      if (groupId > 0) {
        let g = this.selectedCategoryGroups.find(
          x => parseInt(x.ID) === groupId
        );
        return !!(g && parseInt(g.IS_OTHER) === 1);
      }
      return false;
    },
    //если в категории единственная группа и она с признаком "Иное" -
    //возвращаем её, чтобы скрыть select группы и сразу выбрать "Иное"
    singleOtherGroup() {
      const groups = this.selectedCategoryGroups;
      if (groups.length === 1 && parseInt(groups[0].IS_OTHER) === 1) {
        return groups[0];
      }
      return null;
    },

    cGroupStartSelect() {
      //#79664
      let t = [];
      t = this.directory.tree_group_med_oborudovanie.filter(
        c =>
          c.UF_IS_SET_BLOCK_FIELD === 0 &&
          c.UF_SUPPORT_PROGRAM_ID.indexOf(
            this.$parent.project.UF_SUPPORT_PROG_ID
          ) >= 0
      );


      if (this.$parent.project.UF_SETTING && this.$parent.project.UF_SETTING.IGNORE_GROUP_MED_OBORUDOVINIE){
        let t1 = [];
        t1 = t.filter(
          c => !this.$parent.project.UF_SETTING.IGNORE_GROUP_MED_OBORUDOVINIE.includes(c.ID)
        );
        t = t1;
      }

      let list = [];
      t.forEach(function(el) {
        let ver = 1;
        if (
          this.programCode(this.$parent.project.UF_SUPPORT_PROG_ID) ===
          "lekarstva"
        ) {
          ver = 2;
        }

        if (el.CHILD) {
          let ch = el.CHILD.filter(
            c =>
              c.VERSION === ver &&
              c.INDUSTRY.indexOf(this.$parent.project.UF_INDUSTRY_ID) >= 0
          );

          if (ch.length > 0) {
            list.push(el);
          }
        }
      }, this);

      return list;
    },

    cGroup() {
      if (this.item.UF_VID_GROUP_ID < 1) {
        return [];
      }
      let t = null;
      t = this.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === this.item.UF_VID_GROUP_ID
      );
      if (t[0]) {
        let ver = 1;
        if (
          this.programCode(this.$parent.project.UF_SUPPORT_PROG_ID) ===
          "lekarstva"
        ) {
          ver = 2;
        }
        let ch = t[0].CHILD.filter(
          c =>
            c.VERSION === ver &&
            c.INDUSTRY.indexOf(this.$parent.project.UF_INDUSTRY_ID) >= 0
        );
        return ch;
      }
      return [];
    },
    purchasedEquipment() {
      let t = this.directory.tree_industry.filter(
        c => c.ID === this.$parent.project.UF_INDUSTRY_ID
      );
      if (t.length > 0) {
        console.log(
          "this.$parent.directory.tree_group_med_oborudovanie: ",
          JSON.parse(
            JSON.stringify(this.$parent.directory.tree_group_med_oborudovanie)
          )
        );
        return t[0].CODE;
      }
      return [];
    }
  },
  methods: {
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID == id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    },
    showAddItem() {
      this.setError("");
      this.showForm = true;
      this.editIndex = -1;
      this.item = {};
      this.item.UF_SORT_NUMBER = (this.$parent.project.PURCHASED_EQUIPMENT.items.length + 1);
    },
    editItem(index) {
      this.setError("");
      this.editIndex = index;
      this.item = JSON.parse(
        JSON.stringify(this.$parent.project.PURCHASED_EQUIPMENT.items[index])
      );
      //если в категории единственная группа "Иное" - выбираем её,
      //чтобы скрытый select группы имел значение, а поле описания открылось
      if (this.singleOtherGroup && !this.item.UF_CATEGORIES_GROUP_ID) {
        this.$set(
          this.item,
          "UF_CATEGORIES_GROUP_ID",
          this.singleOtherGroup.ID
        );
      }
      this.showForm = true;
    },
    deleteItem(index, item) {
      this.item = item;
      if (confirm("Вы уверены, что хотите удалить запись?")) {
        this.deleteItemAction(index, item);
      }
    },
    deleteItemAction(index){
      ProjectsService.deleteEqipmentProject(this.$parent.project.ID, this.nameEquipment, this.item.ID).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 10000
            });
          }, this);
        } else {
          this.$toasted.show("Запись успешно удалена", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });

          this.$parent.project.PURCHASED_EQUIPMENT.items.splice(index, 1);

          this.$parent.project.PURCHASED_EQUIPMENT.items.forEach(function(itemTemp, index2) {
            if (index2 >= index) {
              this.$parent.project.PURCHASED_EQUIPMENT.items[index2].UF_SORT_NUMBER= parseInt(itemTemp.UF_SORT_NUMBER) - 1;
            }
          }, this);

        }
      }, this).catch(error => {
        this.handleModuleBlocked(error);
      });
    },
    handleModuleBlocked(error) {
      const status = (error && error.response && error.response.status) || 0;
      const messageHas403 = error && error.message && error.message.indexOf("403") !== -1;
      if (status === 403 || messageHas403) {
        this.$toasted.show("Модуль заблокирован Сотрудником ДМКП", {
          theme: "red",
          position: "bottom-right",
          duration: 10000
        });
      }
    },
    submit() {
      this.setError("");
      if (!this.item.UF_DESCRIPTION) {
        this.setError("UF_DESCRIPTION");
      }
      //поля "Группа оборудования"/"Вид оборудования" проверяем только когда
      //справочник "Категория и группа" НЕ отображается (они скрыты при viewCategories)
      if (!this.viewCategories) {
        if (!this.item.UF_VID_GROUP_ID) {
          this.setError("UF_VID_GROUP_ID");
        }
        if (!this.item.UF_VID_ID) {
          this.setError("UF_VID_ID");
        }
      }
      if (
        !this.item.UF_COUNT_FROM ||
        !this.item.UF_COUNT_TO ||
        parseFloat(this.item.UF_COUNT_FROM) > parseFloat(this.item.UF_COUNT_TO)
      ) {
        this.setError("UF_COUNT_FROM");
      }

      //проверка полей справочника "Категории закупаемого оборудования"
      //(только при включенном признаке EQUIPMENT_CATEGORIES_VIEW)
      if (this.viewCategories) {
        const catId = parseInt(this.item.UF_CATEGORIES_ID) || 0;
        const groupId = parseInt(this.item.UF_CATEGORIES_GROUP_ID) || 0;
        //если заполнено одно из полей "Категория"/"Группа" - должны быть заполнены оба
        if ((catId > 0 && groupId === 0) || (catId === 0 && groupId > 0)) {
          if (catId === 0) {
            this.setError("UF_CATEGORIES_ID");
          }
          if (groupId === 0) {
            this.setError("UF_CATEGORIES_GROUP_ID");
          }
        }
        //если выбранная группа имеет признак "Иное" (IS_OTHER=1) - описание обязательно
        if (
          groupId > 0 &&
          this.selectedGroupIsOther &&
          !(this.item.UF_CATEGORIES_DESC && this.item.UF_CATEGORIES_DESC.trim())
        ) {
          this.setError("UF_CATEGORIES_DESC");
        }
      }

      if (Object.keys(this.errorFields).length) {
        return;
      }
      if (this.editIndex > -1) {
        //редактирование записи
        ProjectsService.saveEqipmentProject(this.$parent.project.ID, this.nameEquipment, this.item.ID, this.item).then(({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          } else {
            this.$toasted.show("Запись успешно изменена", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });

            this.$parent.project.PURCHASED_EQUIPMENT.items[
              this.editIndex
              ] = JSON.parse(JSON.stringify(this.item));

            this.showForm = false;
          }
        }, this).catch(error => {
          this.handleModuleBlocked(error);
        });

      } else {
        ProjectsService.addEqipmentProject(this.$parent.project.ID, this.nameEquipment, this.item).then(({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 10000
              });
            }, this);
          } else {
            this.$toasted.show("Запись успешно добавлена", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
            this.item.ID = data.ID;
            this.$parent.project.PURCHASED_EQUIPMENT.items.push(this.item);
            this.showForm = false;
          }
        }, this).catch(error => {
          this.handleModuleBlocked(error);
        });
      }

      return false;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setError(field, val) {
      if (!field) {
        this.errorFields = {};
        return;
      }
      this.errorFields[field] = val ? val : true;
    },
    checkError(field) {
      if (this.errorFields[field]) {
        return true;
      }
      return false;
    },
    medName(item) {
      const result = this.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === item
      );
      if (!result.length) {
        return "";
      }
      return result[0].NAME;
    },
    groupCode(item, group) {
      const result = this.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === item
      );
      if (!result.length) {
        return "";
      }
      const vid = result[0].CHILD.filter(c => c.ID === group);
      console.log(vid);
      if (!vid.length) {
        return "";
      }
      return vid[0].CODE;
    },
    groupName(item, group) {
      const result = this.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === item
      );
      if (!result.length) {
        return "";
      }
      const vid = result[0].CHILD.filter(c => c.ID === group);
      console.log(vid);
      if (!vid.length) {
        return "";
      }
      return vid[0].NAME;
    },
    onCategoryChange() {
      //при смене категории сбрасываем группу и описание
      this.$set(this.item, "UF_CATEGORIES_GROUP_ID", undefined);
      this.$set(this.item, "UF_CATEGORIES_DESC", "");
      //если в категории единственная группа "Иное" - скрываем select группы,
      //автоматически выбираем её и открываем поле описания группы
      if (this.singleOtherGroup) {
        this.$set(
          this.item,
          "UF_CATEGORIES_GROUP_ID",
          this.singleOtherGroup.ID
        );
      }
    },
    onGroupChange() {
      //если выбранная группа без признака "Иное" - очищаем описание
      if (!this.selectedGroupIsOther) {
        this.$set(this.item, "UF_CATEGORIES_DESC", "");
      }
    },
    getCategoryName(id) {
      id = parseInt(id) || 0;
      if (id > 0) {
        let c = this.categoriesTree.find(x => parseInt(x.ID) === id);
        if (c) {
          return c.NAME;
        }
      }
      return "";
    },
    getGroupInfo(groupId) {
      groupId = parseInt(groupId) || 0;
      if (groupId > 0) {
        for (let i = 0; i < this.categoriesTree.length; i++) {
          let childs = this.categoriesTree[i].CHILD;
          if (Array.isArray(childs)) {
            let g = childs.find(x => parseInt(x.ID) === groupId);
            if (g) {
              return g;
            }
          }
        }
      }
      return null;
    },
    getGroupDisplay(item) {
      let g = this.getGroupInfo(item.UF_CATEGORIES_GROUP_ID);
      if (!g) {
        return "";
      }
      //для группы с признаком "Иное" выводим свободный ввод текста (UF_CATEGORIES_DESC)
      return parseInt(g.IS_OTHER) === 1 ? item.UF_CATEGORIES_DESC || "" : g.NAME;
    },
    getCountryName(id) {
      id = parseInt(id) || 0;
      if (id > 0) {
        let c = this.directory.country.find(x => parseInt(x.ID) === id);
        if (c) {
          return c.NAME;
        }
      }
      return "";
    }
  }
};
</script>

<style scoped>
/* Окно «Изменить позицию» теперь не выходит за пределы экрана:
   контент ограничен высотой вьюпорта, шапка зафиксирована,
   прокручивается только тело модального окна. */
.modal-content {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}
.modal-header {
  flex: 0 0 auto;
}
.modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
</style>
